import request from '@/utils/request'


// 查询礼物记录列表
export function listCommunityLiveGiftRecord(query) {
  return request({
    url: '/community/admin/community/live/gift/record/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询礼物记录分页
export function pageCommunityLiveGiftRecord(query) {
  return request({
    url: '/community/admin/community/live/gift/record/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询礼物记录详细
export function getCommunityLiveGiftRecord(data) {
  return request({
    url: '/community/admin/community/live/gift/record/detail',
    method: 'get',
    params: data
  })
}

// 新增礼物记录
export function addCommunityLiveGiftRecord(data) {
  return request({
    url: '/community/admin/community/live/gift/record/add',
    method: 'post',
    data: data
  })
}

// 修改礼物记录
export function updateCommunityLiveGiftRecord(data) {
  return request({
    url: '/community/admin/community/live/gift/record/edit',
    method: 'post',
    data: data
  })
}

// 删除礼物记录
export function delCommunityLiveGiftRecord(data) {
  return request({
    url: '/community/admin/community/live/gift/record/delete',
    method: 'post',
    data: data
  })
}
